import { IonIcon, IonImg, IonRouterLink } from '@ionic/react';
import React from 'react';

import footerBackground from '@/assets/images/hero/background.png';
import appStoreLogo from '@/assets/images/stores/black/app-store.png';
import googlePlayStoreLogo from '@/assets/images/stores/black/google-play.png';
import { Spacer } from '@/components/common';
import { ROUTES } from '@/utils/routes';
import {
  logoFacebook,
  logoLinkedin,
  logoYoutube,
  mailOutline
} from 'ionicons/icons';

import './Footer.css';

const Footer: React.FC = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <div
        className="footer"
        style={{ backgroundImage: `url(${footerBackground})` }}
      >
        <p className="footer__prompt">
          <span>Level up</span> your dental practice
          <br />
          Get the <span>app</span> now.
        </p>
        <Spacer top={16} />
        <div className="footer__download-buttons">
          <IonRouterLink
            href="https://play.google.com/store/apps/details?id=ph.odonto.dashboard"
            target="_blank"
          >
            <IonImg src={googlePlayStoreLogo} />
          </IonRouterLink>
          <IonRouterLink
            href="https://apps.apple.com/ph/app/odonto/id6737960471"
            target="_blank"
          >
            <IonImg src={appStoreLogo} />
          </IonRouterLink>
        </div>
        <Spacer top={42} />
        <div className="footer__links">
          <a href="#to-faqs">FAQs</a>
          <a
            href={ROUTES.TERMS_OF_SERVICE}
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms
          </a>
          <a
            href={ROUTES.PRIVACY_POLICY}
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
        </div>
        <Spacer top={16} />
        <div className="footer__stay-connected">
          <div className="footer__social-icons">
            <a
              href="https://www.facebook.com/OdontoPhilippines"
              target="_blank"
              rel="noopener noreferrer"
            >
              <IonIcon icon={logoFacebook} className="footer__facebook-icon" />
            </a>
            <a
              href="https://www.linkedin.com/in/carlrosales"
              target="_blank"
              rel="noopener noreferrer"
            >
              <IonIcon icon={logoLinkedin} className="footer__linkedin-icon" />
            </a>
            <a
              href="https://www.youtube.com/@OdontoPhilippines"
              target="_blank"
              rel="noopener noreferrer"
            >
              <IonIcon icon={logoYoutube} className="footer__youtube-icon" />
            </a>
            <a
              href="mailto:hello@odonto.ph"
              target="_blank"
              rel="noopener noreferrer"
            >
              <IonIcon
                icon={mailOutline}
                className="footer__mail-icon"
                color="primary"
              />
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
